import { MixpanelEvent } from './mixpanel-events'
import { CREATE_SAFE_EVENTS } from './events/createLoadSafe'
import { WALLET_EVENTS } from './events/wallet'
import { SAFE_APPS_EVENTS } from './events/safeApps'
import { POSITIONS_EVENTS } from './events/positions'
import { PORTFOLIO_EVENTS } from './events/portfolio'
import { STAKE_EVENTS } from './events/stake'
import { EARN_EVENTS } from './events/earn'
import { WALLETCONNECT_EVENTS } from './events/walletconnect'
import { TX_LIST_EVENTS } from './events/txList'
import { SWAP_EVENTS } from './events/swaps'
import { EXPLORE_POSSIBLE_EVENTS, OVERVIEW_EVENTS } from './events/overview'
import { NESTED_SAFE_EVENTS } from './events/nested-safes'
import { SAFE_SHIELD_EVENTS } from './events/safe-shield'
import { HYPERNATIVE_EVENTS } from './events/hypernative'
import { TX_EVENTS } from './events/transactions'
import { SPACE_EVENTS } from './events/spaces'
import { POLICY_EVENTS } from './events/policies'
import { SAFE_PRO_EVENTS } from './events/safe-pro'

// If an event is mapped here, it will be tracked in Mixpanel
export const GA_TO_MIXPANEL_MAPPING: Record<string, string> = {
  [CREATE_SAFE_EVENTS.CREATED_SAFE.action]: MixpanelEvent.SAFE_CREATED,
  [CREATE_SAFE_EVENTS.ACTIVATED_SAFE.action]: MixpanelEvent.SAFE_ACTIVATED,
  [WALLET_EVENTS.CONNECT.action]: MixpanelEvent.WALLET_CONNECTED,
  [SAFE_APPS_EVENTS.OPEN_APP.action]: MixpanelEvent.SAFE_APP_LAUNCHED,
  [POSITIONS_EVENTS.POSITION_EXPANDED.action]: MixpanelEvent.POSITION_EXPANDED,
  [POSITIONS_EVENTS.POSITIONS_VIEW_ALL_CLICKED.action]: MixpanelEvent.POSITIONS_VIEW_ALL_CLICKED,
  [POSITIONS_EVENTS.EMPTY_POSITIONS_EXPLORE_CLICKED.action]: MixpanelEvent.EMPTY_POSITIONS_EXPLORE_CLICKED,
  [PORTFOLIO_EVENTS.PORTFOLIO_REFRESH_CLICKED.action]: MixpanelEvent.PORTFOLIO_REFRESH_CLICKED,
  [STAKE_EVENTS.STAKE_VIEWED.action]: MixpanelEvent.STAKE_VIEWED,
  [EARN_EVENTS.EARN_VIEWED.action]: MixpanelEvent.EARN_VIEWED,
  [WALLETCONNECT_EVENTS.CONNECTED.action]: MixpanelEvent.WC_CONNECTED,
  [TX_LIST_EVENTS.CSV_EXPORT_CLICKED.action]: MixpanelEvent.CSV_TX_EXPORT_CLICKED,
  [TX_LIST_EVENTS.CSV_EXPORT_SUBMITTED.action]: MixpanelEvent.CSV_TX_EXPORT_SUBMITTED,
  [SWAP_EVENTS.OPEN_SWAPS.action]: MixpanelEvent.NATIVE_SWAP_VIEWED,
  [OVERVIEW_EVENTS.SIDEBAR_CLICKED.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.NEW_TRANSACTION.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.SIDEBAR.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.WHATS_NEW.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.HELP_CENTER.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.SHOW_QR.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.COPY_ADDRESS.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [OVERVIEW_EVENTS.OPEN_EXPLORER.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [NESTED_SAFE_EVENTS.OPEN_LIST.action]: MixpanelEvent.SIDEBAR_CLICKED,
  [HYPERNATIVE_EVENTS.GUARDIAN_BANNER_VIEWED.action]: MixpanelEvent.GUARDIAN_BANNER_VIEWED,
  [HYPERNATIVE_EVENTS.GUARDIAN_FORM_VIEWED.action]: MixpanelEvent.GUARDIAN_FORM_VIEWED,
  [HYPERNATIVE_EVENTS.GUARDIAN_FORM_STARTED.action]: MixpanelEvent.GUARDIAN_FORM_STARTED,
  [HYPERNATIVE_EVENTS.GUARDIAN_FORM_SUBMITTED.action]: MixpanelEvent.GUARDIAN_FORM_SUBMITTED,
  [HYPERNATIVE_EVENTS.SECURITY_REPORT_CLICKED.action]: MixpanelEvent.SECURITY_REPORT_CLICKED,
  [HYPERNATIVE_EVENTS.GUARDIAN_BANNER_DISMISSED.action]: MixpanelEvent.GUARDIAN_BANNER_DISMISSED,
  [HYPERNATIVE_EVENTS.HYPERNATIVE_LOGIN_CLICKED.action]: MixpanelEvent.HYPERNATIVE_LOGIN_CLICKED,
  [HYPERNATIVE_EVENTS.HYPERNATIVE_CONNECTED.action]: MixpanelEvent.HYPERNATIVE_CONNECTED,
  [HYPERNATIVE_EVENTS.HYPERNATIVE_FULL_REPORT_CLICKED.action]: MixpanelEvent.HYPERNATIVE_FULL_REPORT_CLICKED,
  [SAFE_SHIELD_EVENTS.REPORT_SUBMITTED.action]: MixpanelEvent.FALSE_RESULT_REPORTED,
  [EXPLORE_POSSIBLE_EVENTS.EXPLORE_POSSIBLE_CLICKED.action]: MixpanelEvent.EXPLORE_POSSIBLE_CLICKED,
  [OVERVIEW_EVENTS.OPEN_EURCV_BOOST.action]: MixpanelEvent.EURCV_BOOST_BANNER_CLICKED,
  [OVERVIEW_EVENTS.HIDE_EURCV_BOOST_BANNER.action]: MixpanelEvent.EURCV_BOOST_BANNER_DISMISSED,
  [SAFE_SHIELD_EVENTS.TRANSACTION_STARTED.action]: MixpanelEvent.TRANSACTION_STARTED,
  [SAFE_SHIELD_EVENTS.RECIPIENT_DECODED.action]: MixpanelEvent.TRANSACTION_RECIPIENT_DECODED,
  [SAFE_SHIELD_EVENTS.CONTRACT_DECODED.action]: MixpanelEvent.TRANSACTION_CONTRACT_DECODED,
  [SAFE_SHIELD_EVENTS.THREAT_ANALYZED.action]: MixpanelEvent.TRANSACTION_THREAT_ANALYZED,
  [SAFE_SHIELD_EVENTS.SIMULATED.action]: MixpanelEvent.TRANSACTION_SIMULATED,
  [TX_EVENTS.EXECUTE.action]: MixpanelEvent.TRANSACTION_EXECUTED,
  [TX_EVENTS.EXECUTE_VIA_PARENT.action]: MixpanelEvent.TRANSACTION_EXECUTED_VIA_PARENT,
  [TX_EVENTS.EXECUTE_IN_PARENT.action]: MixpanelEvent.TRANSACTION_EXECUTED_IN_PARENT,
  [TX_EVENTS.EXECUTE_VIA_ROLE.action]: MixpanelEvent.TRANSACTION_EXECUTED_VIA_ROLE,
  [TX_EVENTS.CREATE.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.CREATE_VIA_ROLE.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.CREATE_VIA_PROPOSER.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.CREATE_VIA_PARENT.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.CREATE_VIA_SPENDING_LIMTI.action]: MixpanelEvent.TRANSACTION_SUBMITTED,
  [TX_EVENTS.EXECUTE_VIA_SPENDING_LIMIT.action]: MixpanelEvent.TRANSACTION_EXECUTED,
  [OVERVIEW_EVENTS.TRUSTED_SAFES_ADDED.action]: MixpanelEvent.TRUSTED_SAFE_ADDED,
  [OVERVIEW_EVENTS.TRUSTED_SAFES_REMOVED.action]: MixpanelEvent.TRUSTED_SAFE_REMOVED,
  [POLICY_EVENTS.POLICY_CATALOGUE_TILE_CLICKED.action]: MixpanelEvent.POLICY_CATALOGUE_TILE_CLICKED,
  [POLICY_EVENTS.POLICY_UPSELL_UPGRADE_CLICKED.action]: MixpanelEvent.POLICY_UPSELL_UPGRADE_CLICKED,
  [POLICY_EVENTS.ADD_POLICY_DIALOG_CLOSED.action]: MixpanelEvent.ADD_POLICY_DIALOG_CLOSED,
  [POLICY_EVENTS.PROPOSER_SUBMITTED.action]: MixpanelEvent.PROPOSER_SUBMITTED,
  [POLICY_EVENTS.SPENDING_LIMIT_SET.action]: MixpanelEvent.SPENDING_LIMIT_SET,
  [POLICY_EVENTS.SPENDING_LIMIT_TX_CONFIRMED.action]: MixpanelEvent.SPENDING_LIMIT_TX_CONFIRMED,
  [POLICY_EVENTS.SPENDING_LIMIT_TX_SIGNED.action]: MixpanelEvent.SPENDING_LIMIT_TX_SIGNED,
  [SPACE_EVENTS.WORKSPACE_CREATED.action]: MixpanelEvent.WORKSPACE_CREATED,
  [SPACE_EVENTS.WORKSPACE_DASHBOARD_VIEWED.action]: MixpanelEvent.WORKSPACE_DASHBOARD_VIEWED,
  [SPACE_EVENTS.AUTH_LOGIN_SUCCEEDED.action]: MixpanelEvent.AUTH_LOGIN_SUCCEEDED,
  [SPACE_EVENTS.AUTH_LOGIN_FAILED.action]: MixpanelEvent.AUTH_LOGIN_FAILED,
  [SPACE_EVENTS.AUTH_LOGGED_OUT.action]: MixpanelEvent.AUTH_LOGGED_OUT,
  [SPACE_EVENTS.SAFE_SELECTED.action]: MixpanelEvent.SAFE_SELECTED,
  [SPACE_EVENTS.CHAIN_SWITCHED.action]: MixpanelEvent.CHAIN_SWITCHED,
  [SPACE_EVENTS.WORKSPACE_SAFE_LINK_STARTED.action]: MixpanelEvent.WORKSPACE_SAFE_LINK_STARTED,
  [SPACE_EVENTS.WORKSPACE_SAFE_LINKED.action]: MixpanelEvent.WORKSPACE_SAFE_LINKED,
  [SPACE_EVENTS.WORKSPACE_SAFE_UNLINKED.action]: MixpanelEvent.WORKSPACE_SAFE_UNLINKED,
  [SPACE_EVENTS.ACCOUNTS_WIDGET_CLICKED.action]: MixpanelEvent.ACCOUNTS_WIDGET_CLICKED,
  [SPACE_EVENTS.PENDING_TX_WIDGET_CLICKED.action]: MixpanelEvent.PENDING_TX_WIDGET_CLICKED,
  [SPACE_EVENTS.WALLET_SWITCHED.action]: MixpanelEvent.WALLET_SWITCHED,
  [SPACE_EVENTS.WALLET_DISCONNECTED.action]: MixpanelEvent.WALLET_DISCONNECTED,
  [SPACE_EVENTS.WORKSPACE_CREATE_STARTED.action]: MixpanelEvent.WORKSPACE_CREATE_STARTED,
  [SPACE_EVENTS.WORKSPACE_MEMBER_INVITE_SENT.action]: MixpanelEvent.WORKSPACE_MEMBER_INVITE_SENT,
  [SPACE_EVENTS.WORKSPACE_MEMBER_INVITE_ACCEPTED.action]: MixpanelEvent.WORKSPACE_MEMBER_INVITE_ACCEPTED,
  [SPACE_EVENTS.WORKSPACE_MEMBER_ROLE_CHANGED.action]: MixpanelEvent.WORKSPACE_MEMBER_ROLE_CHANGED,
  [SPACE_EVENTS.WORKSPACE_MEMBER_REMOVED.action]: MixpanelEvent.WORKSPACE_MEMBER_REMOVED,
  [SPACE_EVENTS.DECLINE_INVITE_SUBMIT.action]: MixpanelEvent.WORKSPACE_MEMBER_INVITE_DECLINED,
  [SPACE_EVENTS.WORKSPACE_SWITCHED.action]: MixpanelEvent.WORKSPACE_SWITCHED,
  [SPACE_EVENTS.ADDRESS_BOOK_ENTRY_CREATED.action]: MixpanelEvent.ADDRESS_BOOK_ENTRY_CREATED,
  [SPACE_EVENTS.TRANSACTION_INITIATED.action]: MixpanelEvent.WORKSPACE_TRANSACTION_INITIATED,
  [SPACE_EVENTS.ONBOARDING_WIZARD.action]: MixpanelEvent.ONBOARDING_WIZARD,
  [SPACE_EVENTS.USE_OLD_UI.action]: MixpanelEvent.USE_OLD_UI,
  [SPACE_EVENTS.DELETE_SPACE.action]: MixpanelEvent.WORKSPACE_DELETED,
  [SPACE_EVENTS.LEAVE_SPACE.action]: MixpanelEvent.WORKSPACE_LEFT,
  [SPACE_EVENTS.WORKSPACE_MEMBER_INVITE_RENEWED.action]: MixpanelEvent.WORKSPACE_MEMBER_INVITE_RENEWED,
  [SPACE_EVENTS.ADD_ACCOUNTS.action]: MixpanelEvent.WORKSPACE_ACCOUNTS_ADDED,
  [SPACE_EVENTS.ADD_ACCOUNT_MANUALLY.action]: MixpanelEvent.WORKSPACE_ACCOUNT_ADDED_MANUALLY,
  [SPACE_EVENTS.DELETE_ACCOUNT.action]: MixpanelEvent.WORKSPACE_ACCOUNT_DELETED,
  [SPACE_EVENTS.CREATE_SPACE_TX.action]: MixpanelEvent.WORKSPACE_SEND_TX_STARTED,
  [SPACE_EVENTS.EDIT_ADDRESS_SUBMIT.action]: MixpanelEvent.WORKSPACE_ADDRESS_EDITED,
  [SPACE_EVENTS.REMOVE_ADDRESS_SUBMIT.action]: MixpanelEvent.WORKSPACE_ADDRESS_REMOVED,
  [SPACE_EVENTS.IMPORT_ADDRESS_BOOK_SUBMIT.action]: MixpanelEvent.WORKSPACE_ADDRESS_BOOK_IMPORTED,
  [SPACE_EVENTS.WORKSPACE_UPDATED.action]: MixpanelEvent.WORKSPACE_UPDATED,
  [SPACE_EVENTS.SECURITY_HUB_VIEWED.action]: MixpanelEvent.SECURITY_HUB_VIEWED,
  [SPACE_EVENTS.SECURITY_REPORT_OPENED.action]: MixpanelEvent.SECURITY_REPORT_OPENED,
  [SPACE_EVENTS.ACTIVITY_LOG_VIEWED.action]: MixpanelEvent.ACTIVITY_LOG_VIEWED,
  [SPACE_EVENTS.ACTIVITY_LOG_FILTERED.action]: MixpanelEvent.ACTIVITY_LOG_FILTERED,
  [SPACE_EVENTS.ADDRESS_REQUEST_SENT.action]: MixpanelEvent.WORKSPACE_ADDRESS_REQUEST_SENT,
  [SPACE_EVENTS.ADDRESS_REQUEST_APPROVED.action]: MixpanelEvent.WORKSPACE_ADDRESS_REQUEST_APPROVED,
  [SPACE_EVENTS.ADDRESS_REQUEST_REJECTED.action]: MixpanelEvent.WORKSPACE_ADDRESS_REQUEST_REJECTED,
  [SPACE_EVENTS.LOCAL_CONTACT_ADDED.action]: MixpanelEvent.WORKSPACE_LOCAL_CONTACT_ADDED,
  [SAFE_PRO_EVENTS.SAFE_PRO_BANNER_VIEWED.action]: MixpanelEvent.SAFE_PRO_BANNER_VIEWED,
  [SAFE_PRO_EVENTS.FREE_ACCESS_OFFER_VIEWED.action]: MixpanelEvent.FREE_ACCESS_OFFER_VIEWED,
  [SAFE_PRO_EVENTS.FREE_ACCESS_CLAIM_CLICKED.action]: MixpanelEvent.FREE_ACCESS_CLAIM_CLICKED,
  [SAFE_PRO_EVENTS.FREE_ACCESS_OFFER_DISMISSED.action]: MixpanelEvent.FREE_ACCESS_OFFER_DISMISSED,
  [SAFE_PRO_EVENTS.SAFE_ACCOUNT_SELECTION_VIEWED.action]: MixpanelEvent.SAFE_ACCOUNT_SELECTION_VIEWED,
  [SAFE_PRO_EVENTS.SAFE_ACCOUNT_SELECTION_SUBMITTED.action]: MixpanelEvent.SAFE_ACCOUNT_SELECTION_SUBMITTED,
  [SAFE_PRO_EVENTS.WORKSPACE_CREATE_STEP_VIEWED.action]: MixpanelEvent.WORKSPACE_CREATE_STEP_VIEWED,
  [SAFE_PRO_EVENTS.PLAN_SELECTION_STARTED.action]: MixpanelEvent.PLAN_SELECTION_STARTED,
  [SAFE_PRO_EVENTS.PLANS_PAGE_VIEWED.action]: MixpanelEvent.PLANS_PAGE_VIEWED,
  [SAFE_PRO_EVENTS.PLAN_CTA_CLICKED.action]: MixpanelEvent.PLAN_CTA_CLICKED,
  [SAFE_PRO_EVENTS.PLAN_CHANGE_CONFIRMED.action]: MixpanelEvent.PLAN_CHANGE_CONFIRMED,
  [SAFE_PRO_EVENTS.CHECKOUT_STARTED.action]: MixpanelEvent.CHECKOUT_STARTED,
  [SAFE_PRO_EVENTS.CHECKOUT_RETURNED.action]: MixpanelEvent.CHECKOUT_RETURNED,
  [SAFE_PRO_EVENTS.FREE_ACCESS_REMINDER_VIEWED.action]: MixpanelEvent.FREE_ACCESS_REMINDER_VIEWED,
  [SAFE_PRO_EVENTS.WORKSPACE_LOCKED_VIEWED.action]: MixpanelEvent.WORKSPACE_LOCKED_VIEWED,
  [SAFE_PRO_EVENTS.UPGRADE_PROMPT_VIEWED.action]: MixpanelEvent.UPGRADE_PROMPT_VIEWED,
}

// Maps GA labels (lowercase) to Mixpanel properties (Title Case)
export const GA_LABEL_TO_MIXPANEL_PROPERTY: Record<string, string> = {
  asset: 'Assets',
  dashboard_assets: 'Home',
  sidebar: 'Sidebar',
  newTransaction: 'New Transaction',
}
